var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",attrs:{"data-type":_vm.data.type||null}},[_c('div',[_vm._v(_vm._s(_vm.data.text))]),_c('button',{on:{"click":_vm.close}},[_vm._v("x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }